import React from 'react';
import PropTypes from 'prop-types';
import { BodyMedium, BodySmall, DividerBlueStyled, H3 } from '@react/styledComponents';
import { useScreenMinMd, useScreenSmDown } from '@hooks/useResponsive';
import classNames from 'classnames';

const AccountInformationFormHeader = ({ isNew }) => {
    const isScreenMinMd = useScreenMinMd();
    const isScreenSmDown = useScreenSmDown();

    let headingText;
    let bodyText;

    if (!isNew) {
        headingText = 'Account Info';
        bodyText = "Before you check out, let's make sure your information is up-to-date.";
    } else {
        headingText = 'Create an Account';
        bodyText = 'Please fill out this form to become an ICSC member.';
    }

    return (
        <div>
            <H3>{headingText}</H3>
            {isScreenMinMd && <BodyMedium>{bodyText}</BodyMedium>}
            {isScreenSmDown && <BodySmall className="mt-0.5rem">{bodyText}</BodySmall>}

            <DividerBlueStyled
                className={classNames('mb-2.5rem', {
                    'mt-2.5rem': isScreenMinMd,
                    'mt-1.5rem': isScreenSmDown,
                })}
            />
        </div>
    );
};

AccountInformationFormHeader.propTypes = {
    isNew: PropTypes.bool.isRequired,
};

export default AccountInformationFormHeader;
